<template>

    <div v-if="isPaxPage">
        <!-- <pre class="“language-json”"><code>{{ sSearchObj  }}</code></pre> -->

        <div  class="flight-info-wrap">
<!--            <div @click="isSelInfoShowState=!isSelInfoShowState" v-if="sSearchObj" class="head">-->
            <div  v-if="sSearchObj" class="head">
<div class="form-title d-flex ai-center">
    <h2>
      {{$t('selFlightInfo.flightDetails')}}
    </h2>
    <button class=" blue-primary-btn booking-btn" type="button" @click="goToSearchPage">
        <span> {{$t('selFlightInfo.modifySearch')}}</span> </button>
</div>

<!--                <div class="place">-->
<!--                    <div>{{sSearchObj.route[0].from.depcode.city}}</div>-->
<!--                    <div>-->
<!--                        -->
<!--                        <img src="@imgPath/img/svg/icons/direction-left-right.svg" alt width="20px"/>-->
<!--                    </div>-->
<!--                    <div>{{sSearchObj.route[0].to.depcode.city}}</div>-->
<!--                </div>-->
<!--                <div class="details">-->
<!--                    <div class="left">-->
<!--                        <span>{{sSearchObj.route[0].date|formatDate("MMMM DD, YYYY")}} |</span>-->
<!--                        <span v-if="sSearchObj.trip==2"> {{sSearchObj.route[1].date|formatDate("MMMM DD, YYYY")}}</span>-->
<!--                        <span> | {{sSearchObj.pax.adultCount}} {{$t('searchPage.adult')}}</span>-->
<!--                        <span v-if="sSearchObj.pax.childCount>0"> | {{sSearchObj.pax.childCount}} {{$t('searchPage.child')}}</span>-->
<!--                        <span v-if="sSearchObj.pax.infantCount>0"> | {{sSearchObj.pax.infantCount}} {{$t('searchPage.infant')}}</span>-->

<!--                    </div>-->
<!--                    <div class="right">-->
<!--            <span @click.stop="goToSearchPage" class="ms-wrap">-->
<!--              <img src="https://image.flaticon.com/icons/svg/1159/1159876.svg" alt width=" 15px"/>-->
<!--              <span>Modify Search</span>-->
<!--            </span>-->
<!--                    </div>-->
<!--                </div>-->


            </div>
<!--            <transition name="bounce">-->
<!--               -->
<!--            </transition>-->
            <div v-if="isSelInfoShowState" class="body">
                <div @click="toShowDepConnectingInfo=!toShowDepConnectingInfo" class="depart">
                    <div v-if="sSelectedPricing&&sSelectedPricing.data"
                         class="flight-title"
                    >
                        {{$t('selFlightInfo.departureFlight')}} :
                        {{sSelectedPricing.data.data.airports[selflightObj.ob.obFlight[0].flight.DepAirport].city}}
                        -
                        {{sSelectedPricing.data.data.airports[selflightObj.ob.obFlight[selflightObj.ob.obFlight.length-1].flight.ArrAirport].city}}
                    </div>
                    <div v-if="selflightObj.ob" class="content">
                        <div class="airport-details">
                            <div v-if="selflightObj.ob.obFlight.length==1" class="wrap">
                                <div
                                        class="date"
                                >{{selflightObj.ob.obFlight[0].flight.DepDate|formatDate(DATE_TIME_FORMAT.MONTH_DATE)}}
                                </div>
                                <div class="time">{{selflightObj.ob.obFlight[0].flight.DepDate|formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)}}</div>
                                <div class="airport">
                                    <div class="point"></div>
                                    {{selflightObj.ob.obFlight[0].flight.DepAirport|cityName}}
                                </div>
                            </div>
                            <div
                                    v-for="(selFlight,index ) in selflightObj.ob.obFlight"
                                    :key="selFlight.flight.FlightNo"
                                    :class="index!=selflightObj.ob.obFlight.length-1?'wrap':''"
                            >
                                <div
                                        v-if="index!=selflightObj.ob.obFlight.length-1"
                                        class="date"
                                >{{selFlight.flight.DepDate|formatDate(DATE_TIME_FORMAT.MONTH_DATE)}}
                                </div>
                                <div
                                        v-if="index!=selflightObj.ob.obFlight.length-1"
                                        class="time"
                                >{{selFlight.flight.DepDate|formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)}}
                                </div>
                                <div class="wrap" v-if="selflightObj.ob.obFlight.length>1 && index==selflightObj.ob.obFlight.length-1">
                                <div
                                        v-if="selflightObj.ob.obFlight.length>1 && index==selflightObj.ob.obFlight.length-1"
                                        class="date"
                                >{{selFlight.flight.DepDate|formatDate(DATE_TIME_FORMAT.MONTH_DATE)}}
                                </div>
                                <div
                                       v-if="selflightObj.ob.obFlight.length>1 && index==selflightObj.ob.obFlight.length-1" 
                                        class="time"
                                >{{selFlight.flight.DepDate|formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)}}
                                </div>
                                
                                <div v-if="selflightObj.ob.obFlight.length>1 && index==selflightObj.ob.obFlight.length-1" class="airport">
                                    <div class="point"></div>
                                    {{selFlight.flight.DepAirport|cityName}}
                                </div>
                                </div>
                                
                                
                                <div class="wrap" v-if="index==selflightObj.ob.obFlight.length-1">
                                <div 
                                        
                                        class="date"
                                >{{selFlight.flight.ArrDate|formatDate(DATE_TIME_FORMAT.MONTH_DATE)}}
                                </div>
                                <div
                                        class="time"
                                >{{selFlight.flight.ArrDate|formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)}}
                                </div>
                                
                                <div  class="airport">
                                    <div class="point"></div>
                                    {{selFlight.flight.ArrAirport|cityName}}
                                </div>
                                </div>
                                 <div v-if="index!=selflightObj.ob.obFlight.length-1" class="airport">
                                    <div class="point"></div>
                                    {{selFlight.flight.DepAirport|cityName}}
                                </div>
                            </div>
                            <!-- <div class="wrap">
                              <div class="date">Feb 3</div>
                              <div class="time">17:35</div>
                              <div class="airport">
                                <div class="point"></div>Taoyuan International Airport T2
                              </div>
                            </div>-->
                        </div>
                        <div class="flight-det">

                            <div class="logo">

                                <!-- <img :src="$options.filters.ALimage(selflightObj.ob.obFlight[0].flight.opAirline)"
                                     :onerror="defaultALImg" alt width="20px"/> -->
                                     <img v-if="selflightObj && selflightObj.ob && selflightObj.ob.obFlight[0].flight.opAirline
                                         && GET_AIRLINES && GET_AIRLINES[selflightObj.ob.obFlight[0].flight.opAirline].logourl"
                                :src="GET_AIRLINES[selflightObj.ob.obFlight[0].flight.opAirline].logourl || defaultALImg"
                                alt width="20px"/>
                                <img v-else :src="defaultALImg" alt width="20px"/>
                            </div>
                            <div v-if="selflightObj && selflightObj.ob && selflightObj.ob.obFlight[0].flight" class="details">
                                <div v-if="selflightObj.ob.obFlight[0].flight.opAirline
                                         && GET_AIRLINES && GET_AIRLINES[selflightObj.ob.obFlight[0].flight.opAirline]">
                                  {{GET_AIRLINES[selflightObj.ob.obFlight[0].flight.opAirline].airline_name}}
                                  <!-- {{selflightObj.ob.obFlight[0].flight.opAirline|airlineName}} -->
                                    <!-- {{$t('flightResults.airlines')}} -->
                                </div>
                                <div>
<!--                                    <span>{{selflightObj.ob.obFlight[0].flight.opAirline+' | '+selflightObj.ob.obFlight[0].flight.FlightNo}}</span>-->
                                    <span>{{selflightObj.ob.obFlight[0].flight.FlightNo}}</span>
                                    |
                                    <span v-if="!isStopsForNonMyanmar"
                              class="stop"
                        >{{selflightObj.ob.obFlight && selflightObj.ob.obFlight[0].flight.no_of_stops && selflightObj.ob.obFlight[0].flight.no_of_stops.name}}</span>
                        
                        <span v-else-if="isStopsForNonMyanmar && selflightObj.ob.obFlight.length==1"
                                class="via"
                        >{{selflightObj.ob.obFlight && selflightObj.ob.obFlight[0] && selflightObj.ob.obFlight[0].flight.Via_Obj}}</span>
                        <span v-else-if="isStopsForNonMyanmar && selflightObj.ob.obFlight.length>1"
                                class="via"
                        ><span>
                          
                          {{selflightObj.ob.obFlight && selflightObj.ob.obFlight[0] && selflightObj.ob.obFlight[0].flight.no_of_stops && selflightObj.ob.obFlight[0].flight.no_of_stops.name}}</span>
                <span >
                  {{selflightObj.ob.obFlight[0].flight.Via_Obj != 'Non-Stop'?'| '+selflightObj.ob.obFlight[0].flight.Via_Obj:null}}
                  </span>
                  </span>
                |
                                    <!-- <span>Boeing 787</span>| -->
                                    <span>{{$t('selFlightInfo.class')}} {{selflightObj.ob.obFlight[0].flight.Bookingclass}}</span>
                                     <!-- <span> {{selflightObj.ob.obFlight[0].flight.Via_Obj?'| '+selflightObj.ob.obFlight[0].flight.Via_Obj:''}}</span> -->

                                </div>
                            </div>
                            <div class="duration">
                                <div>{{selflightObj.ob.obFlight[0].flight.TotalDuration | convertToHrMin("minutes","H [h] mm [m]") }}</div>
                                <div class="image">
                                    <div v-if="selflightObj.ob && selflightObj.ob.obFlight && selflightObj.ob.obFlight[0].flight.baggage"
                                     class="luggage d-flex ai-center">
                                      <!-- /img/Suitcase_icon.b6c12de8.svg -->
                              <img src="@imgPath/img/svg/icons/Suitcase_icon.svg" alt="" width="16px"/>

                                        <span 
                                                class="ml-5px"
                                        >{{selflightObj.ob.obFlight[0].flight.baggage[0].weightinkg}}{{$t('selFlightInfo.kiloGram')}}</span>
                                        
                                    </div>
                                    <!--                                                            <img src="https://image.flaticon.com/icons/svg/685/685352.svg"-->
                                    <!--                                                                 alt="" width="10px">-->
                                    <!--                                                            <img src="https://image.flaticon.com/icons/svg/685/685352.svg"-->
                                    <!--                                                                 alt="" width="10px">-->
                                    <!--                                                            <img src="https://image.flaticon.com/icons/svg/685/685352.svg"-->
                                    <!--                                                                 alt="" width="10px">-->
                                </div>
                                <!--                                                            <img src="https://image.flaticon.com/icons/svg/685/685352.svg"-->
                                <!--                                                                 alt="" width="10px">-->
                                <!--                                                            <img src="https://image.flaticon.com/icons/svg/685/685352.svg"-->
                                <!--                                                                 alt="" width="10px">-->
                                <!--                                                            <img src="https://image.flaticon.com/icons/svg/685/685352.svg"-->
                                <!--                                                                 alt="" width="10px">-->
                            </div>
                        </div>
                        
                    </div>
                                                <!-- <cConnectingFlightInfo v-if="toShowDepConnectingInfo && selflightObj.ob.obFlight.length>1" :flightObject="selflightObj.ob.obFlight"></cConnectingFlightInfo> -->

                </div>
                <div @click="toShowRetConnectingInfo=!toShowRetConnectingInfo" class="depart"
                 v-if="selflightObj && selflightObj.ib  && sSelectedPricing && sSelectedPricing.data && sSelectedPricing.data.data">
                    <div
                         class="flight-title">{{$t('selFlightInfo.returnFlight')}} :
                        {{sSelectedPricing.data.data.airports[selflightObj.ib.ibFlight[0].flight.DepAirport].city}}
                        -
                        {{sSelectedPricing.data.data.airports[selflightObj.ib.ibFlight[selflightObj.ib.ibFlight.length-1].flight.ArrAirport].city}}
                    </div>
                    <div v-if="selflightObj.ib" class="content">
                        <div class="airport-details">
                            <div v-if="selflightObj.ib.ibFlight.length==1" class="wrap">
                                <div
                                        class="date"
                                >{{selflightObj.ib.ibFlight[0].flight.DepDate|formatDate(DATE_TIME_FORMAT.MONTH_DATE)}}
                                </div>
                                <div class="time">{{selflightObj.ib.ibFlight[0].flight.DepDate|formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)}}</div>
                                <div class="airport">
                                    <div class="point"></div>
                                    {{selflightObj.ib.ibFlight[0].flight.DepAirport|cityName}}
                                </div>
                            </div>
                            <div
                                    v-for="(selFlight,index ) in selflightObj.ib.ibFlight"
                                    :key="selFlight.flight.FlightNo"
                                    :class="index!=selflightObj.ib.ibFlight.length-1?'wrap':''"
                            >
                                <div
                                        v-if="index!=selflightObj.ib.ibFlight.length-1"
                                        class="date"
                                >{{selFlight.flight.DepDate|formatDate(DATE_TIME_FORMAT.MONTH_DATE)}}
                                </div>
                                
                                <div
                                        v-if="index!=selflightObj.ib.ibFlight.length-1"
                                        class="time"
                                >{{selFlight.flight.DepDate|formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)}}
                                </div>

                                <div class="wrap"  v-if="selflightObj.ib.ibFlight.length>1 && index==selflightObj.ib.ibFlight.length-1">
                                <div
                                       
                                        class="date"
                                >{{selFlight.flight.DepDate|formatDate(DATE_TIME_FORMAT.MONTH_DATE)}}
                                </div>
                                <div
                                        class="time"
                                >{{selFlight.flight.DepDate|formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)}}
                                </div>
                                
                                <div class="airport">
                                    <div class="point"></div>
                                    {{selFlight.flight.DepAirport|cityName}}
                                </div>
                                </div>
                                <div class="wrap"  v-if="index==selflightObj.ib.ibFlight.length-1">
                                <div
                                        class="date"
                                >{{selFlight.flight.ArrDate|formatDate(DATE_TIME_FORMAT.MONTH_DATE)}}
                                </div>
                                <div
                                        class="time"
                                >{{selFlight.flight.ArrDate|formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)}}
                                </div>

                                <div  class="airport">
                                    <div class="point"></div>
                                    {{selFlight.flight.ArrAirport|cityName}}
                                </div>
                                </div>
                                <div v-if="index!=selflightObj.ib.ibFlight.length-1" class="airport">
                                    <div class="point"></div>
                                    {{selFlight.flight.DepAirport|cityName}}
                                </div>
                            </div>
                            <!-- <div class="wrap">
                              <div class="date">Feb 3</div>
                              <div class="time">17:35</div>
                              <div class="airport">
                                <div class="point"></div>Taoyuan International Airport T2
                              </div>
                            </div>-->
                        </div>
                        <div class="flight-det">
                            <div class="logo">
                              <img v-if="selflightObj && selflightObj.ib && selflightObj.ib.ibFlight[0].flight.opAirline
                                  && GET_AIRLINES && GET_AIRLINES[selflightObj.ib.ibFlight[0].flight.opAirline].logourl"
                                :src="GET_AIRLINES[selflightObj.ib.ibFlight[0].flight.opAirline].logourl || defaultALImg"
                                 alt width="20px"/>
                                <img v-else :src="defaultALImg" alt width="20px"/>
                                <!-- <img :src="$options.filters.ALimage(selflightObj.ib.ibFlight[0].flight.opAirline)"
                                     onerror="javascript:this.src='https://a24-b2b.s3-ap-southeast-1.amazonaws.com/logo/svg/default.svg'"
                                     alt width="20px"/> -->
                            </div>
                            <div v-if="selflightObj && selflightObj.ib && selflightObj.ib.ibFlight[0].flight" class="details">

                                <div v-if="selflightObj.ib.ibFlight[0].flight.opAirline
                                  && GET_AIRLINES && GET_AIRLINES[selflightObj.ib.ibFlight[0].flight.opAirline]">
                                  {{GET_AIRLINES[selflightObj.ib.ibFlight[0].flight.opAirline].airline_name}}
                                  <!-- {{selflightObj.ib.ibFlight[0].flight.opAirline|airlineName }} -->
                                    <!-- {{$t('flightResults.airlines')}} -->
                                </div>
                                <div>
<!--                                    <span>{{selflightObj.ib.ibFlight[0].flight.opAirline+' | '+selflightObj.ib.ibFlight[0].flight.FlightNo}}</span>-->
                                    <span>{{selflightObj.ib.ibFlight[0].flight.FlightNo}}</span>
                                    |
                                     <span v-if="!isStopsForNonMyanmar"
                              class="stop"
                        > {{selflightObj.ib.ibFlight && selflightObj.ib.ibFlight[0].flight.no_of_stops && selflightObj.ib.ibFlight[0].flight.no_of_stops.name}}</span>
                        <span v-else-if="isStopsForNonMyanmar && selflightObj.ib.ibFlight.length==1 "
                                class="via"
                        > 
                        
                   
                        
                        {{ (selflightObj.ib.ibFlight && selflightObj.ib.ibFlight[0] && selflightObj.ib.ibFlight[0].flight.Via_Obj)}}</span>
                        <span v-else-if="isStopsForNonMyanmar && selflightObj.ib.ibFlight.length>1"
                                class="via"
                        ><span>{{selflightObj.ib.ibFlight && selflightObj.ib.ibFlight[0] && selflightObj.ib.ibFlight[0].flight.no_of_stops && selflightObj.ib.ibFlight[0].flight.no_of_stops.name}}</span>

                <span > {{selflightObj.ib.ibFlight[0].flight.Via_Obj != 'Non-Stop'?'| '+selflightObj.ib.ibFlight[0].flight.Via_Obj:null}}</span>
                
                </span>

               
                
                                    <!-- <span v-if="selflightObj.ib.ibFlight.length>1"> {{selflightObj.ib.ibFlight.length-1==1 ? selflightObj.ib.ibFlight.length-1+' '+$t('selFlightInfo.stop')+' ' :
                                                                                       selflightObj.ib.ibFlight.length-1+' '+$t('selFlightInfo.stops')+' ' }}</span> -->
                                    |
                                    <!-- <span>Boeing 787</span>| -->
                                    <span>{{$t('selFlightInfo.class')}} {{selflightObj.ib.ibFlight[0].flight.Bookingclass}}</span>
                                     <!-- <span> {{selflightObj.ib.ibFlight[0].flight.Via_Obj?'| '+selflightObj.ib.ibFlight[0].flight.Via_Obj:''}}</span> -->

                                </div>
                            </div>
                            <div class="duration">
                                <div>{{selflightObj.ib.ibFlight[0].flight.TotalDuration | convertToHrMin("minutes","H [h] mm [m]") }}</div>
                                <div class="image">
                                    <div v-if="selflightObj.ib && selflightObj.ib.ibFlight[0] &&selflightObj.ib.ibFlight[0].flight.baggage" 
                                    class="luggage d-flex ai-center">
                                      <!-- /img/Suitcase_icon.b6c12de8.svg -->
                                    
                                        <img src="@imgPath/img/svg/icons/Suitcase_icon.svg" alt="" width="16px"/>
                                        <span 
                                                class="ml-5px"
                                        >{{selflightObj.ib.ibFlight[0].flight.baggage[0].weightinkg}}{{$t('selFlightInfo.kiloGram')}}</span>
                                    </div>
                                    <!--                                                            <img src="https://image.flaticon.com/icons/svg/685/685352.svg"-->
                                    <!--                                                                 alt="" width="10px">-->
                                    <!--                                                            <img src="https://image.flaticon.com/icons/svg/685/685352.svg"-->
                                    <!--                                                                 alt="" width="10px">-->
                                    <!--                                                            <img src="https://image.flaticon.com/icons/svg/685/685352.svg"-->
                                    <!--                                                                 alt="" width="10px">-->
                                </div>
                                <!--                                                            <img src="https://image.flaticon.com/icons/svg/685/685352.svg"-->
                                <!--                                                                 alt="" width="10px">-->
                                <!--                                                            <img src="https://image.flaticon.com/icons/svg/685/685352.svg"-->
                                <!--                                                                 alt="" width="10px">-->
                                <!--                                                            <img src="https://image.flaticon.com/icons/svg/685/685352.svg"-->
                                <!--                                                                 alt="" width="10px">-->
                            </div>
                        </div>
                    </div>
                            <!-- <cConnectingFlightInfo v-if="toShowRetConnectingInfo && selflightObj.ib.ibFlight.length>1" :flightObject="selflightObj.ib.ibFlight"></cConnectingFlightInfo> -->

                </div>
            </div>
            <div v-if="isSelInfoShowState" class="foot">
                <div class="align-left" @click="isFRModalshow=!isFRModalshow">{{$t('selFlightInfo.viewFareRules')}}</div>
                <!-- <div class="r">Cancellation fees and baggage allowance ></div> -->
            </div>
        </div>
        <div class="farerule-wrapper">
            <!-- <cFareRule
                    v-if="sSelectedPricing&&sSelectedPricing.data.data.pUnits[0].PricingInfo.fareRule"
                    :buttonList="[
                {name:$t('userStatus.ok'),func:onToggleFRModal,color:'success'},]"
                    :show="isFRModalshow"
                    :fareRuleData="sSelectedPricing.data.data.pUnits[0].PricingInfo.fareRule"
             @updateShow="isFRModalshow=!isFRModalshow"
            ></cFareRule> -->
            
            
            <cFareRule
                    v-if="sSelectedPricing&&sSelectedPricing.data.data.pUnits[0].PricingInfo.fareRule"
                    :buttonList="[
                {name:$t('userStatus.ok'),func:onToggleFRModal,color:'success'},]"
                    :show="isFRModalshow"
                    :fareRuleData="sSelectedPricing.data.data.pUnits"
                @updateShow="isFRModalshow=!isFRModalshow"
            ></cFareRule>
        </div>


           <!-- <div >
         <div v-if="selflightObj.ob || selflightObj.ib">
           <div v-if="selflightObj.ob" class="info-wrap">
             <div class="flight-title"><div>Depart Flight</div></div>
             <div class="flight-name">
               <div class="logo">
                 <img :src="$options.filters.ALimage(selflightObj.ob.obFlight && selflightObj.ob.obFlight[0].flight.opAirline)"
                       onerror="javascript:this.src='https://a24-b2b.s3-ap-southeast-1.amazonaws.com/logo/svg/default.svg'">
                 &lt;!&ndash; <img src="https://image.flaticon.com/icons/svg/806/806041.svg" alt /> &ndash;&gt;
               </div>
               <div class="name">
                 <div>{{selflightObj.ob.obFlight[0].flight.opAirline|airlineName}}</div>
                 <div class="d-flex flex-flow-column">
                 <span
                         class="flight-code"
                 >{{selflightObj.ob.obFlight[0].flight.opAirline+' '+selflightObj.ob.obFlight[0].flight.FlightNo}}</span>
                   <span
                           class="flight-code"
                   >{{selflightObj.ob.obFlight[0].flight.DepDate|formatDate(DATE_TIME_FORMAT.DAY_DATE_MONTH)}}</span>
                 </div>
               </div>
             </div>
             <div class="time-place-wrap">
               <div class="left">
                 <div
                         class="time"
                         v-c-tooltip.hover="{
                                 content:`${formatDate(selflightObj.ob.obFlight[0].flight.DepDate)}
                                 on ${formatTime(selflightObj.ob.obFlight[0].flight.DepDate)}
                                   `,
                               }"
                 >{{selflightObj.ob.obFlight[0].flight.DepDate|formatDate()}}</div>
                 <div class="place-code">{{selflightObj.ob.obFlight[0].flight.DepAirport}}</div>
                 <div class="place">{{getFlightName(selflightObj.ob.obFlight[0].flight.DepAirport)}}</div>
               </div>
               <div class="center">
                 <span>{{selflightObj.ob.obFlight[0].flight.TotalDuration|convertToHrMin("minutes","H [h] mm [m]")}}</span>
                 <img src="/img/flying-flight.88d11502.svg" alt />
                 &lt;!&ndash; <span>{{selflightObj.ob.obFlight[0].flight.no_of_stops.name}}</span> &ndash;&gt;
                 &lt;!&ndash;            <span>{{selflightObj.ob.obFlight[0].flight.Via_Obj}}</span>&ndash;&gt;
                 <span>Non Stop</span>
               </div>
               <div class="right">
                 <div
                         class="time"
                         v-c-tooltip.hover="{
                                 content:`${formatDate(selflightObj.ob.obFlight[selflightObj.ob.obFlight.length-1].flight.ArrDate)}
                                 on ${formatTime(selflightObj.ob.obFlight[selflightObj.ob.obFlight.length-1].flight.ArrDate)}
                                   `,
                               }"
                 >{{selflightObj.ob.obFlight[selflightObj.ob.obFlight.length-1].flight.ArrDate|formatDate()}}</div>
                 <div
                         class="place-code"
                 >{{selflightObj.ob.obFlight[selflightObj.ob.obFlight.length-1].flight.ArrAirport}}</div>
                 <div
                         class="place"
                 >{{getFlightName(selflightObj.ob.obFlight[selflightObj.ob.obFlight.length-1].flight.ArrAirport)}}</div>
               </div>
             </div>
             <div class="luggage d-flex">
               <span>Class B</span>
             </div>
           </div>

           &lt;!&ndash; Ib filght &ndash;&gt;
           <div v-if="selflightObj.ib" class="info-wrap">
             <div class="flight-title"><div>Return Flight</div></div>
             <div class="flight-name">
               <div class="logo">
                 <img :src="$options.filters.ALimage(selflightObj.ib.ibFlight && selflightObj.ib.ibFlight[0].flight.opAirline)"
                      :onerror="defaultALImg">
                 &lt;!&ndash; <img src="https://image.flaticon.com/icons/svg/806/806041.svg" alt /> &ndash;&gt;
               </div>
               <div class="name">
                 <div>{{selflightObj.ib.ibFlight[0].flight.opAirline|airlineName}}</div>
                 <div class="d-flex flex-flow-column">
                 <span
                         class="flight-code"
                 >{{selflightObj.ib.ibFlight[0].flight.opAirline+' '+selflightObj.ib.ibFlight[0].flight.FlightNo}}</span>
                   <span
                           class="flight-code"
                   >{{selflightObj.ib.ibFlight[0].flight.DepDate|formatDate("ddd, DD MMM")}}</span>
                 </div>
               </div>
             </div>
             <div class="time-place-wrap">
               <div class="left">
                 <div
                         class="time"
                         v-c-tooltip.hover="{
                                 content:`${formatDate(selflightObj.ib.ibFlight[0].flight.DepDate)}
                                 on ${formatTime(selflightObj.ib.ibFlight[0].flight.DepDate)}
                                   `,
                               }"
                 >{{selflightObj.ib.ibFlight[0].flight.DepDate|formatDate()}}</div>
                 <div class="place-code">{{selflightObj.ib.ibFlight[0].flight.DepAirport}}</div>
                 <div class="place">{{getFlightName(selflightObj.ib.ibFlight[0].flight.DepAirport)}}</div>
               </div>
               <div class="center">
                 <span>{{selflightObj.ib.ibFlight[0].flight.TotalDuration|convertToHrMin("minutes","H [h] mm [m]")}}</span>
                 <img src="/img/flying-flight.88d11502.svg" alt />
                 &lt;!&ndash; <span>{{selflightObj.ib.ibFlight[0].flight.no_of_stops.name}}</span> &ndash;&gt;
                 &lt;!&ndash;            <span>{{selflightObj.ib.ibFlight[0].flight.Via_Obj}}</span>&ndash;&gt;
                 <span>Non Stop</span>
               </div>
               <div class="right">
                 <div
                        v-c-tooltip.hover="{
                                 content:`${formatDate(selflightObj.ib.ibFlight[selflightObj.ib.ibFlight.length-1].flight.ArrDate)}
                                 on ${formatTime(selflightObj.ib.ibFlight[selflightObj.ib.ibFlight.length-1].flight.ArrDate)}
                                   `,
                               }"
                 >{{selflightObj.ib.ibFlight[0].flight.ArrDate|formatDate()}}</div>
                 <div
                         class="place-code"
                 >{{selflightObj.ib.ibFlight[selflightObj.ib.ibFlight.length-1].flight.ArrAirport}}</div>
                 <div
                         class="place"
                 >{{getFlightName(selflightObj.ib.ibFlight[selflightObj.ib.ibFlight.length-1].flight.ArrAirport)}}</div>
               </div>
             </div>
             <div class="luggage d-flex">
               <span>Class B</span>
             </div>
           </div>
         </div>
       </div>
     </div> -->

    </div>
    <div v-else class="card info-flight nw_booking_summary">

            <div class="title-bs">
                <div class="left w-100"> {{$t('selFlightInfo.bookingSummary')}}</div>
            </div>
            <div @click="toShowDepConnectingInfo=!toShowDepConnectingInfo" class="main-info-wrap divider" v-if="selflightObj&&selflightObj.ob">
                <div class="selected-f-wrap">
                    <div class="info-wrap" >
                        <div class="flight-title">
                            <div>{{$t('selFlightInfo.departFlight')}}</div>
                        </div>
                        <div class="flight-name">
                            <div class="logo"> 
                              <!-- <img :src="$options.filters.ALimage(selflightObj.ob.obFlight && selflightObj.ob.obFlight[0].flight.opAirline)"
                       onerror="javascript:this.src='https://a24-b2b.s3-ap-southeast-1.amazonaws.com/logo/svg/default.svg'"> -->
                       <img v-if="GET_AIRLINES && selflightObj  && selflightObj.ob && selflightObj.ob.obFlight && selflightObj.ob.obFlight[0].flight.opAirline
                        && GET_AIRLINES[selflightObj.ob.obFlight[0].flight.opAirline].logourl"
                                :src="GET_AIRLINES[selflightObj.ob.obFlight[0].flight.opAirline].logourl || defaultALImg"
                                 />
                                <img v-else :src="defaultALImg" />
                            </div>
                            <div  v-if="GET_AIRLINES && selflightObj  && selflightObj.ob && selflightObj.ob.obFlight && selflightObj.ob.obFlight[0].flight.opAirline
                        && GET_AIRLINES[selflightObj.ob.obFlight[0].flight.opAirline]" class="name">
                                <div>
                                  <!-- {{selflightObj.ob.obFlight[0].flight.opAirline|airlineName}} -->
                                  {{GET_AIRLINES[selflightObj.ob.obFlight[0].flight.opAirline].airline_name}}
                                  </div>
                                <div class="d-flex flex-flow-column"><span class="flight-code">{{selflightObj.ob.obFlight[0].flight.FlightNo}}</span><span
                                        class="flight-code">{{selflightObj.ob.obFlight[0].flight.DepDate|formatDate(DATE_TIME_FORMAT.DAY_DATE_MONTH)}} </span></div>
                            </div>
                        </div>
                        <div class="time-place-wrap">
                            <div class="left">
                                <div class="time" v-c-tooltip.hover="{
                                 content:`${formatTime(selflightObj.ob.obFlight[0].flight.DepDate)}
                                 on ${formatDate(selflightObj.ob.obFlight[0].flight.DepDate)}
                                   `,
                               }">{{selflightObj.ob.obFlight[0].flight.DepDate|formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)}}</div>
                                <div class="place-code">{{selflightObj.ob.obFlight[0].flight.DepAirport}}</div>
                                <div class="place">{{selflightObj.ob.obFlight[0].flight.DepAirport|cityName}}</div>
                            </div>
                            <!-- $getConst('/img/svg/icons/','flying-flight') -->
<!-- @imgPath/img/svg/icons/flying-flight.svg -->
                            <div class="center"><span>{{selflightObj.ob.obFlight[0].flight.TotalDuration|convertToHrMin("minutes","H [h] mm [m]")}}</span>
                            <img src="@imgPath/img/svg/icons/flying-flight.svg" alt="">
                               <!-- <span>
                             {{selflightObj.ob.obFlight[0].flight.Via_Obj}}</span> -->

<!-- via obj -->
                             <span v-if="!isStopsForNonMyanmar"
                              class="stop"
                        >{{selflightObj.ob.obFlight && selflightObj.ob.obFlight[0].flight.no_of_stops && selflightObj.ob.obFlight[0].flight.no_of_stops.name}}</span>
                             <span v-else-if="isStopsForNonMyanmar && selflightObj.ob.obFlight.length==1"
                                class="via"
                        >{{selflightObj.ob.obFlight[0] && selflightObj.ob.obFlight[0].flight.Via_Obj}}</span>
                        <span v-else-if="isStopsForNonMyanmar && selflightObj.ob.obFlight.length>1"
                                class="via"
                        ><span>{{selflightObj.ob.obFlight[0] && selflightObj.ob.obFlight[0].flight.no_of_stops && selflightObj.ob.obFlight[0].flight.no_of_stops.name}}</span>
                <span >{{selflightObj.ob.obFlight[0].flight.Via_Obj != 'Non-Stop'?selflightObj.ob.obFlight[0].flight.Via_Obj:null}}</span></span>
                                          
                                          <!--  -->
                             
                             </div>
                            <div class="right">
                                <div class="time" v-c-tooltip.hover="{
                                 content:`${formatTime(selflightObj.ob.obFlight[selflightObj.ob.obFlight.length-1].flight.ArrDate)}
                                 on ${formatDate(selflightObj.ob.obFlight[selflightObj.ob.obFlight.length-1].flight.ArrDate)}
                                   `,
                               }">{{selflightObj.ob.obFlight[selflightObj.ob.obFlight.length-1].flight.ArrDate|formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)}}</div>
                                <div class="place-code">{{selflightObj.ob.obFlight[selflightObj.ob.obFlight.length-1].flight.ArrAirport}}</div>
                                <div class="place">{{selflightObj.ob.obFlight[selflightObj.ob.obFlight.length-1].flight.ArrAirport|cityName}}</div>
                            </div>
                        </div>
                        <div class="luggage d-flex" :class="getClass(selflightObj.ob.obFlight[0].flight.Bookingclass)"><div>Class</div><div > {{selflightObj.ob.obFlight[0].flight.Bookingclass}}</div></div>
                        <div class="remove-flight-sele" v-if="isSticky && selflightObj.ob" @click="removeSelFlights(selflightObj.ob)">
                               <span >&times;</span>
                        </div>
                        
                    </div>
                    
<!--                  <button v-if="isSticky && selflightObj.ob" @click="removeSelFlights(selflightObj.ob)" type="button" class="close" aria-label="Close">-->
<!--                    <span aria-hidden="true">&times;</span>-->
<!--                      </button>-->
                    <div class="search-modify-wrap " v-if="selflightObj&&selflightObj.ob">
                        <div class="total-price-wrap">
                           
                        <cPerPaxPriceInfo   :isFooter="true"  
                        :isPayment="isPayment"
                        :selflightObj="getSelFlightInfoForOb()"
                        :isSingleCliPricing="!(selflightObj&&selflightObj.ib&&selflightObj.ib.clientPricing)"                     
                                                       />
                        </div>
                    </div>
                    
                    <!-- GET_SELFLIGHT_FOR_FOOTER&&GET_SELFLIGHT_FOR_FOOTER.ob -->


                  
                </div>
                <!-- <div class="card info-flight"> -->
                <cConnectingFlightInfo  v-if="toShowDepConnectingInfo" :isResultPage="false"
                  :flightClass="selflightObj.ob.obFlight[0].flight.Bookingclass" :flightObject="selflightObj.ob.obFlight"></cConnectingFlightInfo>
            <!-- </div> -->
</div>
        <div @click="toShowRetConnectingInfo=!toShowRetConnectingInfo" class="main-info-wrap divider" v-if="selflightObj.ib">
            <div class="selected-f-wrap">
                <div class="info-wrap" >
                    <div class="flight-title">
                        <div>{{$t('selFlightInfo.returnFlight')}} </div>
                    </div>
                    <div class="flight-name">
                        <div class="logo"> 
                          <!-- <img :src="$options.filters.ALimage(selflightObj.ib.ibFlight && selflightObj.ib.ibFlight[0].flight.opAirline)"
                      :onerror="defaultALImg"> -->
                      <img v-if="GET_AIRLINES && selflightObj && selflightObj.ib && selflightObj.ib.ibFlight && selflightObj.ib.ibFlight[0].flight.opAirline
                       && GET_AIRLINES[selflightObj.ib.ibFlight[0].flight.opAirline].logourl"
                                :src="GET_AIRLINES[selflightObj.ib.ibFlight[0].flight.opAirline].logourl || defaultALImg"
                                 />
                                <img v-else :src="defaultALImg" />
                        </div>
                        <div v-if="GET_AIRLINES && selflightObj && selflightObj.ib && selflightObj.ib.ibFlight && selflightObj.ib.ibFlight[0].flight.opAirline
                       && GET_AIRLINES[selflightObj.ib.ibFlight[0].flight.opAirline]" class="name">
                            <div>
                              {{GET_AIRLINES[selflightObj.ib.ibFlight[0].flight.opAirline].airline_name}}
                              <!-- {{selflightObj.ib.ibFlight[0].flight.opAirline|airlineName}} -->
                              </div>
                            <div class="d-flex flex-flow-column"><span class="flight-code">{{selflightObj.ib.ibFlight[0].flight.FlightNo}}</span><span
                                    class="flight-code">{{selflightObj.ib.ibFlight[0].flight.DepDate|formatDate("ddd, DD MMM")}}</span></div>
                        </div>
                    </div>
                    <div class="time-place-wrap">
                        <div class="left">
                            <div class="time"  v-c-tooltip.hover="{
                                 content:`${formatTime(selflightObj.ib.ibFlight[0].flight.DepDate)}
                                 on ${formatDate(selflightObj.ib.ibFlight[0].flight.DepDate)}
                                   `,
                               }">{{selflightObj.ib.ibFlight[0].flight.DepDate|formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)}}</div>
                            <div class="place-code">{{selflightObj.ib.ibFlight[0].flight.DepAirport}}</div>
                            <div class="place">{{selflightObj.ib.ibFlight[0].flight.DepAirport|cityName}}</div>
                        </div>
                        <div class="center"><span>{{selflightObj.ib.ibFlight[0].flight.TotalDuration|convertToHrMin("minutes","H [h] mm [m]")}}</span>
                        <img src="@imgPath/img/svg/icons/flying-flight.svg"
                                                                      alt="">
                          <!-- <span>{{selflightObj.ib.ibFlight[0].flight.Via_Obj}}</span> -->
                <!-- via obj -->
                             <span v-if="!isStopsForNonMyanmar"
                              class="stop"
                        >{{selflightObj.ib.ibFlight && selflightObj.ib.ibFlight[0].flight.no_of_stops && selflightObj.ib.ibFlight[0].flight.no_of_stops.name}}</span>
                             <span v-else-if="isStopsForNonMyanmar && selflightObj.ib.ibFlight.length==1"
                                class="via"
                        >{{selflightObj.ib.ibFlight[0] && selflightObj.ib.ibFlight[0].flight.Via_Obj}}</span>
                        <span v-else-if="isStopsForNonMyanmar && selflightObj.ib.ibFlight.length>1"
                                class="via"
                        ><span>{{selflightObj.ib.ibFlight[0] && selflightObj.ib.ibFlight[0].flight.no_of_stops && selflightObj.ib.ibFlight[0].flight.no_of_stops.name}}</span>
                <span >{{selflightObj.ib.ibFlight[0].flight.Via_Obj != 'Non-Stop'?selflightObj.ib.ibFlight[0].flight.Via_Obj:null}}</span></span>
                                          
                                          <!--  -->
                          </div>
                        <div class="right">
                            <div class="time" v-c-tooltip.hover="{
                                 content:`${formatTime(selflightObj.ib.ibFlight[selflightObj.ib.ibFlight.length-1].flight.ArrDate)}
                                 on ${formatDate(selflightObj.ib.ibFlight[selflightObj.ib.ibFlight.length-1].flight.ArrDate)}
                                   `,
                               }">{{selflightObj.ib.ibFlight[0].flight.ArrDate|formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)}}</div>
                            <div class="place-code">{{selflightObj.ib.ibFlight[selflightObj.ib.ibFlight.length-1].flight.ArrAirport}}</div>
                            <div class="place">{{selflightObj.ib.ibFlight[selflightObj.ib.ibFlight.length-1].flight.ArrAirport|cityName}}</div>
                        </div>
                    </div>
                    <div class="luggage d-flex" :class="getClass(selflightObj.ib.ibFlight[0].flight.Bookingclass)"><div>Class </div><div >{{selflightObj.ib.ibFlight[0].flight.Bookingclass}}</div></div>
                    <div class="remove-flight-sele" v-if="isSticky && selflightObj.ib" @click="removeSelFlights(selflightObj.ib)">
                           <span >&times;</span>
                    </div>
                </div>
                <div class="search-modify-wrap " v-if="selflightObj.ib">
                <div class="total-price-wrap" v-if="selflightObj&&selflightObj.ib&&selflightObj.ib.clientPricing">
                    <!-- <cPerPaxPriceInfo   v-if="selflightObj&&selflightObj.selflightObj&&isPayTypeChanged" :selflightObj="selFlight" :isPayment="selectedPayType.paymentsettingsid?true:false"
                  /> -->

                    <cPerPaxPriceInfo  :isFooter="true" :isPayment="isPayment"
                                       :selflightObj="getSelFlightInfoForIb()"
                    />
                </div>
            </div>
<!--               <CRow>-->
<!--                 <CCol>-->
<!--                  <button v-if="isSticky && selflightObj.ib" @click="removeSelFlights(selflightObj.ib)" type="button" class="close" aria-label="Close">-->
<!--                    <span aria-hidden="true">&times;</span>-->
<!--                      </button>-->
<!--                  </CCol>-->
<!--                 <CCol >-->
<!--                   <div class="search-modify-wrap " v-if="selflightObj.ib" @click="stickyHeightAni =!stickyHeightAni" :class="{'height-ani-256': stickyHeightAni}">-->

<!--                 </CCol>-->
                
                 
<!--               </CRow>-->



            </div>
        <cConnectingFlightInfo v-if="toShowRetConnectingInfo" :isResultPage="false"
          :flightClass="selflightObj.ib.ibFlight[0].flight.Bookingclass" :flightObject="selflightObj.ib.ibFlight"></cConnectingFlightInfo>

        </div>
<div class="main-info-wrap divider">
<div class="total-price-wrap">
  

  <table class="payment-fee-table" 
    v-if="isPayment&&selflightObj&&selflightObj.ob&&selflightObj.ob.clientPricing&&selflightObj.ob.clientPricing.isPaymentFee
    &&selflightObj.ob.clientPricing.PaymentAmount!=null">

        <tbody v-if="isPayment" @click="isPaymentFee = !isPaymentFee"  >

        <tr class="active">
            <td>
                <div> {{selflightObj.ob.clientPricing.displayText?selflightObj.ob.clientPricing.displayText:$t('perPaxPriceInfo.paymentFee')}}</div>
            </td>
            <td>
                <div class="wrapper">
                    <div> </div>
                </div>
            </td>
            <td>
                <div class="currency">{{selflightObj.ob.clientPricing.Currency}}</div>
            </td>
            <td>
                <div class="value">{{selflightObj.ob.clientPricing.PaymentAmount | amountformat}}</div>
            </td>
        </tr>

        </tbody>
  </table>
</div>
</div>
            

         <!-- paymentFee(start) -->

                  <!-- paymentFee(end) -->
<div class="total-price-wrap bt-dash-1px-dark">
   


    <cTotalPriceInfo :isFooter="true" v-if="(selflightObj && selflightObj.ob ||
                                                selflightObj && selflightObj.ib)"
                                                                      :selflightObj="selflightObj"/>
</div>



    </div>
    <!--  working footer sticky start-->

    <!--  <div class="main-info-wrap divider">-->
    <!--    <div v-if="isPaxPage">-->
    <!--      &lt;!&ndash; <pre class="“language-json”"><code>{{ sSearchObj  }}</code></pre> &ndash;&gt;-->

    <!--      <div class="flight-info-wrap">-->
    <!--        <div @click="isSelInfoShowState=!isSelInfoShowState"   v-if="sSearchObj" class="head">-->
    <!--          <div class="place">-->
    <!--            <div>{{sSearchObj.route[0].from.depcode.city}}</div>-->
    <!--            <div>-->
    <!--              <img src="@imgPath/img/svg/icons/direction-left-right.svg" alt width="20px" />-->
    <!--            </div>-->
    <!--            <div>{{sSearchObj.route[0].to.depcode.city}}</div>-->
    <!--          </div>-->
    <!--          <div class="details">-->
    <!--            <div class="left">-->
    <!--              <span>{{sSearchObj.route[0].date|formatDate("MMMM DD, YYYY")}} |</span>-->
    <!--              <span v-if="sSearchObj.trip==2"> {{sSearchObj.route[1].date|formatDate("MMMM DD, YYYY")}}</span>-->
    <!--              <span> | {{sSearchObj.pax.adultCount}} {{$t('searchPage.adult')}}</span>-->
    <!--              <span v-if="sSearchObj.pax.childCount>0"> | {{sSearchObj.pax.childCount}} {{$t('searchPage.child')}}</span>-->
    <!--              <span v-if="sSearchObj.pax.infantCount>0"> | {{sSearchObj.pax.infantCount}} {{$t('searchPage.infant')}}</span>-->

    <!--            </div>-->
    <!--            <div class="right">-->
    <!--            <span @click.stop="goToSearchPage" class="ms-wrap">-->
    <!--              <img src="https://image.flaticon.com/icons/svg/1159/1159876.svg" alt width=" 15px" />-->
    <!--              <span>Modify Search</span>-->
    <!--            </span>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--        <transition name="bounce">-->
    <!--          <div v-if="isSelInfoShowState" class="body">-->
    <!--            <div class="depart">-->
    <!--              <div v-if="sSelectedPricing"-->
    <!--                   class="flight-title"-->
    <!--              >{{$t('selFlightInfo.departureFlight')}} : {{sSelectedPricing.data.data.airports[selflightObj.ob.obFlight[0].flight.DepAirport].city}} - {{sSelectedPricing.data.data.airports[selflightObj.ob.obFlight[selflightObj.ob.obFlight.length-1].flight.ArrAirport].city}}</div>-->
    <!--              <div  v-if="selflightObj.ob" class="content">-->
    <!--                <div class="airport-details">-->
    <!--                  <div v-if="selflightObj.ob.obFlight.length==1" class="wrap">-->
    <!--                    <div-->
    <!--                            class="date"-->
    <!--                    >{{selflightObj.ob.obFlight[0].flight.DepDate|formatDate(DATE_TIME_FORMAT.MONTH_DATE)}}</div>-->
    <!--                    <div class="time">{{selflightObj.ob.obFlight[0].flight.DepDate|formatDate()}}</div>-->
    <!--                    <div class="airport">-->
    <!--                      <div class="point"></div>-->
    <!--                      {{getFlightName(selflightObj.ob.obFlight[0].flight.DepAirport)}}-->
    <!--                    </div>-->
    <!--                  </div>-->
    <!--                  <div-->
    <!--                          v-for="(selFlight,index ) in selflightObj.ob.obFlight"-->
    <!--                          :key="selFlight.flight.FlightNo"-->
    <!--                          class="wrap"-->
    <!--                  >-->
    <!--                    <div-->
    <!--                            v-if="index!=selflightObj.ob.obFlight.length-1"-->
    <!--                            class="date"-->
    <!--                    >{{selFlight.flight.DepDate|formatDate(DATE_TIME_FORMAT.MONTH_DATE)}}</div>-->
    <!--                    <div-->
    <!--                            v-if="index==selflightObj.ob.obFlight.length-1"-->
    <!--                            class="date"-->
    <!--                    >{{selFlight.flight.ArrDate|formatDate(DATE_TIME_FORMAT.MONTH_DATE)}}</div>-->
    <!--                    <div-->
    <!--                            v-if="index!=selflightObj.ob.obFlight.length-1"-->
    <!--                            class="time"-->
    <!--                    >{{selFlight.flight.DepDate|formatDate()}}</div>-->
    <!--                    <div-->
    <!--                            v-if="index==selflightObj.ob.obFlight.length-1"-->
    <!--                            class="time"-->
    <!--                    >{{selFlight.flight.ArrDate|formatDate()}}</div>-->

    <!--                    <div class="airport">-->
    <!--                      <div class="point"></div>-->
    <!--                      {{index==selflightObj.ob.obFlight.length-1?getFlightName(selFlight.flight.ArrAirport):getFlightName(selFlight.flight.DepAirport)}}-->
    <!--                    </div>-->
    <!--                  </div>-->
    <!--                  &lt;!&ndash; <div class="wrap">-->
    <!--                    <div class="date">Feb 3</div>-->
    <!--                    <div class="time">17:35</div>-->
    <!--                    <div class="airport">-->
    <!--                      <div class="point"></div>Taoyuan International Airport T2-->
    <!--                    </div>-->
    <!--                  </div>&ndash;&gt;-->
    <!--                </div>-->
    <!--                <div class="flight-det">-->

    <!--                  <div class="logo">-->

    <!--                    <img :src="$options.filters.ALimage(selflightObj.ob.obFlight[0].flight.opAirline)"  :onerror="defaultALImg" alt width="20px" />-->
    <!--                  </div>-->
    <!--                  <div class="details">-->
    <!--                    <div>{{selflightObj.ob.obFlight[0].flight.opAirline|airlineName}} {{$t('flightResults.airlines')}}</div>-->
    <!--                    <div>-->
    <!--                      <span>{{selflightObj.ob.obFlight[0].flight.opAirline+' | '+selflightObj.ob.obFlight[0].flight.FlightNo}}</span> |-->
    <!--                      &lt;!&ndash; <span>Boeing 787</span>| &ndash;&gt;-->
    <!--                      <span>Class {{selflightObj.ob.obFlight[0].flight.Bookingclass}}</span>-->
    <!--                    </div>-->
    <!--                  </div>-->
    <!--                </div>-->
    <!--                <div class="duration">-->
    <!--                  <div>{{selflightObj.ob.obFlight[0].flight.DurationInMin }}m</div>-->
    <!--                  <div class="image">-->
    <!--                    <div class="luggage d-flex ai-center">-->
    <!--                      <img src="/img/Suitcase_icon.b6c12de8.svg" alt width="16px" />-->
    <!--                      <span-->
    <!--                              class="ml-5px"-->
    <!--                      >{{selflightObj.ob.obFlight[0].flight.baggage[0].weightinkg}}{{$t('selFlightInfo.kiloGram')}}</span>-->
    <!--                    </div>-->
    <!--                    &lt;!&ndash;                                                            <img src="https://image.flaticon.com/icons/svg/685/685352.svg"&ndash;&gt;-->
    <!--                    &lt;!&ndash;                                                                 alt="" width="10px">&ndash;&gt;-->
    <!--                    &lt;!&ndash;                                                            <img src="https://image.flaticon.com/icons/svg/685/685352.svg"&ndash;&gt;-->
    <!--                    &lt;!&ndash;                                                                 alt="" width="10px">&ndash;&gt;-->
    <!--                    &lt;!&ndash;                                                            <img src="https://image.flaticon.com/icons/svg/685/685352.svg"&ndash;&gt;-->
    <!--                    &lt;!&ndash;                                                                 alt="" width="10px">&ndash;&gt;-->
    <!--                  </div>-->
    <!--                </div>-->
    <!--              </div>-->
    <!--            </div>-->
    <!--            <div class="depart">-->
    <!--              <div  v-if="sSelectedPricing && selflightObj.ib" class="flight-title">{{$t('selFlightInfo.returnFlight')}} : {{sSelectedPricing.data.data.airports[selflightObj.ib.ibFlight[0].flight.DepAirport].city}} - {{sSelectedPricing.data.data.airports[selflightObj.ib.ibFlight[selflightObj.ib.ibFlight.length-1].flight.ArrAirport].city}}</div>-->
    <!--              <div   v-if="selflightObj.ib" class="content">-->
    <!--                <div class="airport-details">-->
    <!--                  <div v-if="selflightObj.ib.ibFlight.length==1" class="wrap">-->
    <!--                    <div-->
    <!--                            class="date"-->
    <!--                    >{{selflightObj.ib.ibFlight[0].flight.DepDate|formatDate(DATE_TIME_FORMAT.MONTH_DATE)}}</div>-->
    <!--                    <div class="time">{{selflightObj.ib.ibFlight[0].flight.DepDate|formatDate()}}</div>-->
    <!--                    <div class="airport">-->
    <!--                      <div class="point"></div>-->
    <!--                      {{getFlightName(selflightObj.ib.ibFlight[0].flight.DepAirport)}}-->
    <!--                    </div>-->
    <!--                  </div>-->
    <!--                  <div-->
    <!--                          v-for="(selFlight,index ) in selflightObj.ib.ibFlight"-->
    <!--                          :key="selFlight.flight.FlightNo"-->
    <!--                          class="wrap"-->
    <!--                  >-->
    <!--                    <div-->
    <!--                            v-if="index!=selflightObj.ib.ibFlight.length-1"-->
    <!--                            class="date"-->
    <!--                    >{{selFlight.flight.DepDate|formatDate(DATE_TIME_FORMAT.MONTH_DATE)}}</div>-->
    <!--                    <div-->
    <!--                            v-if="index==selflightObj.ib.ibFlight.length-1"-->
    <!--                            class="date"-->
    <!--                    >{{selFlight.flight.ArrDate|formatDate(DATE_TIME_FORMAT.MONTH_DATE)}}</div>-->
    <!--                    <div-->
    <!--                            v-if="index!=selflightObj.ib.ibFlight.length-1"-->
    <!--                            class="time"-->
    <!--                    >{{selFlight.flight.DepDate|formatDate()}}</div>-->
    <!--                    <div-->
    <!--                            v-if="index==selflightObj.ib.ibFlight.length-1"-->
    <!--                            class="time"-->
    <!--                    >{{selFlight.flight.ArrDate|formatDate()}}</div>-->

    <!--                    <div class="airport">-->
    <!--                      <div class="point"></div>-->
    <!--                      {{index==selflightObj.ib.ibFlight.length-1?getFlightName(selFlight.flight.ArrAirport):getFlightName(selFlight.flight.DepAirport)}}-->
    <!--                    </div>-->
    <!--                  </div>-->
    <!--                  &lt;!&ndash; <div class="wrap">-->
    <!--                    <div class="date">Feb 3</div>-->
    <!--                    <div class="time">17:35</div>-->
    <!--                    <div class="airport">-->
    <!--                      <div class="point"></div>Taoyuan International Airport T2-->
    <!--                    </div>-->
    <!--                  </div>&ndash;&gt;-->
    <!--                </div>-->
    <!--                <div class="flight-det">-->
    <!--                  <div class="logo">-->
    <!--                    <img :src="$options.filters.ALimage(selflightObj.ib.ibFlight[0].flight.opAirline)"  onerror="javascript:this.src='https://a24-b2b.s3-ap-southeast-1.amazonaws.com/logo/svg/default.svg'" alt width="20px" />-->
    <!--                  </div>-->
    <!--                  <div class="details">-->
    <!--                    <div>{{selflightObj.ib.ibFlight[0].flight.opAirline|airlineName }} {{$t('flightResults.airlines')}}</div>-->
    <!--                    <div>-->
    <!--                      <span>{{selflightObj.ib.ibFlight[0].flight.opAirline+' | '+selflightObj.ib.ibFlight[0].flight.FlightNo}}</span> |-->
    <!--                      &lt;!&ndash; <span>Boeing 787</span>| &ndash;&gt;-->
    <!--                      <span>Class {{selflightObj.ib.ibFlight[0].flight.Bookingclass}}</span>-->
    <!--                    </div>-->
    <!--                  </div>-->
    <!--                </div>-->
    <!--                <div class="duration">-->
    <!--                  <div>{{selflightObj.ib.ibFlight[0].flight.DurationInMin }}m</div>-->
    <!--                  <div class="image">-->
    <!--                    <div class="luggage d-flex ai-center">-->
    <!--                      <img src="/img/Suitcase_icon.b6c12de8.svg" alt width="16px" />-->
    <!--                      <span-->
    <!--                              class="ml-5px"-->
    <!--                      >{{selflightObj.ib.ibFlight[0].flight.baggage[0].weightinkg}}{{$t('selFlightInfo.kiloGram')}}</span>-->
    <!--                    </div>-->
    <!--                    &lt;!&ndash;                                                            <img src="https://image.flaticon.com/icons/svg/685/685352.svg"&ndash;&gt;-->
    <!--                    &lt;!&ndash;                                                                 alt="" width="10px">&ndash;&gt;-->
    <!--                    &lt;!&ndash;                                                            <img src="https://image.flaticon.com/icons/svg/685/685352.svg"&ndash;&gt;-->
    <!--                    &lt;!&ndash;                                                                 alt="" width="10px">&ndash;&gt;-->
    <!--                    &lt;!&ndash;                                                            <img src="https://image.flaticon.com/icons/svg/685/685352.svg"&ndash;&gt;-->
    <!--                    &lt;!&ndash;                                                                 alt="" width="10px">&ndash;&gt;-->
    <!--                  </div>-->
    <!--                </div>-->
    <!--              </div>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </transition>-->
    <!--        <div  v-if="isSelInfoShowState" class="foot">-->
    <!--          <div class="left" @click="isFRModalshow=true">{{$t('selFlightInfo.viewFareRules')}}</div>-->
    <!--          &lt;!&ndash; <div class="r">Cancellation fees and baggage allowance ></div> &ndash;&gt;-->
    <!--        </div>-->
    <!--      </div>-->
    <!--      <cFareRule-->
    <!--              v-if="sSelectedPricing.data.data.pUnits[0].PricingInfo.fareRule"-->
    <!--              :buttonList="[-->
    <!--                {name:$t('userStatus.ok'),func:onToggleFRModal,color:'success'},]"-->
    <!--              :show="isFRModalshow"-->
    <!--              :fareRuleData="sSelectedPricing.data.data.pUnits[0].PricingInfo.fareRule"-->
    <!--      ></cFareRule>-->
    <!--    </div>-->


       <!-- <div v-else>-->
    <!--      <div v-if="selflightObj.ob || selflightObj.ib">-->
    <!--        <div v-if="selflightObj.ob" class="info-wrap">-->
    <!--          <div class="flight-title"><div>Depart Flight</div></div>-->
    <!--          <div class="flight-name">-->
    <!--            <div class="logo">-->
    <!--              <img :src="$options.filters.ALimage(selflightObj.ob.obFlight && selflightObj.ob.obFlight[0].flight.opAirline)"-->
    <!--                   onerror="javascript:this.src='https://a24-b2b.s3-ap-southeast-1.amazonaws.com/logo/svg/default.svg'">-->
    <!--              &lt;!&ndash; <img src="https://image.flaticon.com/icons/svg/806/806041.svg" alt /> &ndash;&gt;-->
    <!--            </div>-->
    <!--            <div class="name">-->
    <!--              <div>{{selflightObj.ob.obFlight[0].flight.opAirline|airlineName}}</div>-->
    <!--              <div class="d-flex flex-flow-column">-->
    <!--              <span-->
    <!--                      class="flight-code"-->
    <!--              >{{selflightObj.ob.obFlight[0].flight.opAirline+' '+selflightObj.ob.obFlight[0].flight.FlightNo}}</span>-->
    <!--                <span-->
    <!--                        class="flight-code"-->
    <!--                >{{selflightObj.ob.obFlight[0].flight.DepDate|formatDate(DATE_TIME_FORMAT.DAY_DATE_MONTH)}}</span>-->
    <!--              </div>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--          <div class="time-place-wrap">-->
    <!--            <div class="left">-->
    <!--              <div-->
    <!--                      class="time"-->
    <!--                      v-c-tooltip.hover="{-->
    <!--                              content:`${formatDate(selflightObj.ob.obFlight[0].flight.DepDate)}-->
    <!--                              on ${formatTime(selflightObj.ob.obFlight[0].flight.DepDate)}-->
    <!--                                `,-->
    <!--                            }"-->
    <!--              >{{selflightObj.ob.obFlight[0].flight.DepDate|formatDate()}}</div>-->
    <!--              <div class="place-code">{{selflightObj.ob.obFlight[0].flight.DepAirport}}</div>-->
    <!--              <div class="place">{{getFlightName(selflightObj.ob.obFlight[0].flight.DepAirport)}}</div>-->
    <!--            </div>-->
    <!--            <div class="center">-->
    <!--              <span>{{selflightObj.ob.obFlight[0].flight.TotalDuration|convertToHrMin("minutes","H [h] mm [m]")}}</span>-->
    <!--              <img src="/img/flying-flight.88d11502.svg" alt />-->
    <!--              &lt;!&ndash; <span>{{selflightObj.ob.obFlight[0].flight.no_of_stops.name}}</span> &ndash;&gt;-->
    <!--              &lt;!&ndash;            <span>{{selflightObj.ob.obFlight[0].flight.Via_Obj}}</span>&ndash;&gt;-->
    <!--              <span>Non Stop</span>-->
    <!--            </div>-->
    <!--            <div class="right">-->
    <!--              <div-->
    <!--                      class="time"-->
    <!--                      v-c-tooltip.hover="{-->
    <!--                              content:`${formatDate(selflightObj.ob.obFlight[selflightObj.ob.obFlight.length-1].flight.ArrDate)}-->
    <!--                              on ${formatTime(selflightObj.ob.obFlight[selflightObj.ob.obFlight.length-1].flight.ArrDate)}-->
    <!--                                `,-->
    <!--                            }"-->
    <!--              >{{selflightObj.ob.obFlight[selflightObj.ob.obFlight.length-1].flight.ArrDate|formatDate()}}</div>-->
    <!--              <div-->
    <!--                      class="place-code"-->
    <!--              >{{selflightObj.ob.obFlight[selflightObj.ob.obFlight.length-1].flight.ArrAirport}}</div>-->
    <!--              <div-->
    <!--                      class="place"-->
    <!--              >{{getFlightName(selflightObj.ob.obFlight[selflightObj.ob.obFlight.length-1].flight.ArrAirport)}}</div>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--          <div class="luggage d-flex">-->
    <!--            <span>Class B</span>-->
    <!--          </div>-->
    <!--        </div>-->

    <!--        &lt;!&ndash; Ib filght &ndash;&gt;-->
    <!--        <div v-if="selflightObj.ib" class="info-wrap">-->
    <!--          <div class="flight-title"><div>Return Flight</div></div>-->
    <!--          <div class="flight-name">-->
    <!--            <div class="logo">-->
    <!--              <img :src="$options.filters.ALimage(selflightObj.ib.ibFlight && selflightObj.ib.ibFlight[0].flight.opAirline)"-->
    <!--                   :onerror="defaultALImg">-->
    <!--              &lt;!&ndash; <img src="https://image.flaticon.com/icons/svg/806/806041.svg" alt /> &ndash;&gt;-->
    <!--            </div>-->
    <!--            <div class="name">-->
    <!--              <div>{{selflightObj.ib.ibFlight[0].flight.opAirline|airlineName}}</div>-->
    <!--              <div class="d-flex flex-flow-column">-->
    <!--              <span-->
    <!--                      class="flight-code"-->
    <!--              >{{selflightObj.ib.ibFlight[0].flight.opAirline+' '+selflightObj.ib.ibFlight[0].flight.FlightNo}}</span>-->
    <!--                <span-->
    <!--                        class="flight-code"-->
    <!--                >{{selflightObj.ib.ibFlight[0].flight.DepDate|formatDate("ddd, DD MMM")}}</span>-->
    <!--              </div>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--          <div class="time-place-wrap">-->
    <!--            <div class="left">-->
    <!--              <div-->
    <!--                      class="time"-->
    <!--                      v-c-tooltip.hover="{-->
    <!--                              content:`${formatDate(selflightObj.ib.ibFlight[0].flight.DepDate)}-->
    <!--                              on ${formatTime(selflightObj.ib.ibFlight[0].flight.DepDate)}-->
    <!--                                `,-->
    <!--                            }"-->
    <!--              >{{selflightObj.ib.ibFlight[0].flight.DepDate|formatDate()}}</div>-->
    <!--              <div class="place-code">{{selflightObj.ib.ibFlight[0].flight.DepAirport}}</div>-->
    <!--              <div class="place">{{getFlightName(selflightObj.ib.ibFlight[0].flight.DepAirport)}}</div>-->
    <!--            </div>-->
    <!--            <div class="center">-->
    <!--              <span>{{selflightObj.ib.ibFlight[0].flight.TotalDuration|convertToHrMin("minutes","H [h] mm [m]")}}</span>-->
    <!--              <img src="/img/flying-flight.88d11502.svg" alt />-->
    <!--              &lt;!&ndash; <span>{{selflightObj.ib.ibFlight[0].flight.no_of_stops.name}}</span> &ndash;&gt;-->
    <!--              &lt;!&ndash;            <span>{{selflightObj.ib.ibFlight[0].flight.Via_Obj}}</span>&ndash;&gt;-->
    <!--              <span>Non Stop</span>-->
    <!--            </div>-->
    <!--            <div class="right">-->
    <!--              <div-->
    <!--                      class="time"-->
    <!--                      v-c-tooltip.hover="{-->
    <!--                              content:`${formatDate(selflightObj.ib.ibFlight[selflightObj.ib.ibFlight.length-1].flight.ArrDate)}-->
    <!--                              on ${formatTime(selflightObj.ib.ibFlight[selflightObj.ib.ibFlight.length-1].flight.ArrDate)}-->
    <!--                                `,-->
    <!--                            }"-->
    <!--              >{{selflightObj.ib.ibFlight[0].flight.ArrDate|formatDate()}}</div>-->
    <!--              <div-->
    <!--                      class="place-code"-->
    <!--              >{{selflightObj.ib.ibFlight[selflightObj.ib.ibFlight.length-1].flight.ArrAirport}}</div>-->
    <!--              <div-->
    <!--                      class="place"-->
    <!--              >{{getFlightName(selflightObj.ib.ibFlight[selflightObj.ib.ibFlight.length-1].flight.ArrAirport)}}</div>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--          <div class="luggage d-flex">-->
    <!--            <span>Class B</span>-->
    <!--          </div>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <!--  </div> -->


    <!--  working footer sticky END-->


    <!-- </div>
                                      </div>
    </div>-->
    <!-- {{$t('selFlightInfo.selflights')}} -->
    <!-- <CCard v-show="ob.isObFlight==false">
        <CCardBody v-if="selflightObj.ob">
          <CRow @click="toggleFilghtDesc('ob',true)">
            <CCol>
              <div>{{selflightObj.ob.obFlight[0].flight.DepDate|formatDate(DATE_TIME_FORMAT.DAY_DATE_MONTH)}}</div>
              <div>{{selflightObj.ob.obFlight[0].flight.opAirline+' '+selflightObj.ob.obFlight[0].flight.FlightNo}}</div>
            </CCol>

            <CRow>
              <CCol
                v-c-tooltip.hover="{
                                content:`${formatDate(selflightObj.ob.obFlight[0].flight.DepDate)}
                                 on ${formatTime(selflightObj.ob.obFlight[0].flight.DepDate)}  `,
                              }"
              >{{formatTime(selflightObj.ob.obFlight[0].flight.DepDate)}}</CCol>
              <CCol
                v-c-tooltip.hover="{
                                content:`${formatDate(selflightObj.ob.obFlight[selflightObj.ob.obFlight.length-1].flight.ArrDate)}
                                 on ${formatTime(selflightObj.ob.obFlight[selflightObj.ob.obFlight.length-1].flight.ArrDate)}  `,
                              }"
              >{{formatTime(selflightObj.ob.obFlight[selflightObj.ob.obFlight.length-1].flight.ArrDate)}}</CCol>
            </CRow>

            <CCol>
              <div> {{selflightObj.ob.obFlight[0].flight.TotalDuration|convertToHrMin("minutes",
              "H [h] mm [m]")}}</div>
            <CRow>
              <CCol col="2.5"
                v-c-tooltip.hover="{
                                content:`${getFlightName(selflightObj.ob.obFlight[0].flight.DepAirport)}  `,
                              }"
              >{{selflightObj.ob.obFlight[0].flight.DepAirport}} - </CCol>
              <CCol col="2.5"
                v-c-tooltip.hover="{
                                content:` ${getFlightName(selflightObj.ob.obFlight[selflightObj.ob.obFlight.length-1].flight.ArrAirport)}  `,
                              }"
              >{{selflightObj.ob.obFlight[selflightObj.ob.obFlight.length-1].flight.ArrAirport}}</CCol>
            </CRow>
            </CCol>
            <CCol>


               {{selflightObj.ob.obFlight[0].flight.Via_Obj}}


            </CCol>
          </CRow>
        </CCardBody>
        <hr />
      </CCard>

      <CCollapse v-show="ob.isObFlight==true" class="mt-2">
        <CCard v-if="selflightObj.ob" body-wrapper @click="toggleFilghtDesc('ob',false)">
          <CCol>{{$t('selFlightInfo.departFlight')}} . {{selflightObj.ob.obFlight[0].flight.DepDate|formatDate(DATE_TIME_FORMAT.DAY_DATE_MONTH)}}</CCol>
          <CCol>
            <CRow>
              <CCol
                col="0"
                v-c-tooltip.hover="{
                                content:`${formatDate(selflightObj.ob.obFlight[0].flight.DepDate)}
                                 on ${formatTime(selflightObj.ob.obFlight[0].flight.DepDate)}  `,
                              }"
              >{{formatTime(selflightObj.ob.obFlight[0].flight.DepDate)}}</CCol>
              <CCol col="3">{{getFlightName(selflightObj.ob.obFlight[0].flight.DepAirport)}} ({{selflightObj.ob.obFlight[0].flight.DepAirport}})</CCol>
            </CRow>
          </CCol>
          <CCol v-if="selflightObj.ob.obFlight[0].flight.TotalDuration!=null">{{$t('selFlightInfo.TravlTime')}} - {{selflightObj.ob.obFlight[0].flight.TotalDuration|convertToHrMin("minutes",
              "H [h] mm [m]")}}</CCol>
          <CCol>
            <CRow>
              <CCol
                col="1"
                v-c-tooltip.hover="{
                                content:`${formatDate(selflightObj.ob.obFlight[selflightObj.ob.obFlight.length-1].flight.ArrDate)}
                                 on ${formatTime(selflightObj.ob.obFlight[selflightObj.ob.obFlight.length-1].flight.ArrDate)}  `,
                              }"
              >{{formatTime(selflightObj.ob.obFlight[selflightObj.ob.obFlight.length-1].flight.ArrDate)}}</CCol>
              <CCol>{{getFlightName(selflightObj.ob.obFlight[selflightObj.ob.obFlight.length-1].flight.ArrAirport)}} ({{selflightObj.ob.obFlight[selflightObj.ob.obFlight.length-1].flight.ArrAirport}})</CCol>
            </CRow>
          </CCol>
          <CCol>{{selflightObj.ob.obFlight[0].flight.opAirline+' '+selflightObj.ob.obFlight[0].flight.FlightNo}} . {{selflightObj.ob.obFlight[0].flight.cabin}}</CCol>
        </CCard>
        <hr />
    </CCollapse>-->

    <!-- IB info  -->
    <!-- <CCard v-show="ib.isIbFlight==false">
        <CCardBody v-if="selflightObj.ib">
          <CRow @click="toggleFilghtDesc('ib',true)">
            <CCol>
              <div>{{selflightObj.ib.ibFlight[0].flight.DepDate|formatDate("ddd, DD MMM")}}</div>
              <div>{{selflightObj.ib.ibFlight[0].flight.opAirline+' '+selflightObj.ib.ibFlight[0].flight.FlightNo}}</div>
            </CCol>

            <CRow>
              <CCol
                v-c-tooltip.hover="{
                                content:`${formatDate(selflightObj.ib.ibFlight[0].flight.DepDate)}
                                 on ${formatTime(selflightObj.ib.ibFlight[0].flight.DepDate)}  `,
                              }"
              >{{formatTime(selflightObj.ib.ibFlight[0].flight.DepDate)}}</CCol>
              <CCol
                v-c-tooltip.hover="{
                                content:`${formatDate(selflightObj.ib.ibFlight[selflightObj.ib.ibFlight.length-1].flight.ArrDate)}
                                 on ${formatTime(selflightObj.ib.ibFlight[selflightObj.ib.ibFlight.length-1].flight.ArrDate)}  `,
                              }"
              >{{formatTime(selflightObj.ib.ibFlight[0].flight.ArrDate)}}</CCol>
            </CRow>

            <CCol>
              <div>{{selflightObj.ib.ibFlight[0].flight.TotalDuration|convertToHrMin("minutes",
              "H [h] mm [m]")}}</div>
              <CRow>
                <CCol
                  col="2.5"
                  v-c-tooltip.hover="{
                                content:`${getFlightName(selflightObj.ib.ibFlight[0].flight.DepAirport)}  `,
                              }"
                >{{selflightObj.ib.ibFlight[0].flight.DepAirport+' '}} - </CCol>
                <CCol
                  col="2.5"
                  v-c-tooltip.hover="{
                                content:` ${getFlightName(selflightObj.ib.ibFlight[selflightObj.ib.ibFlight.length-1].flight.ArrAirport)}  `,
                              }"
                >{{selflightObj.ib.ibFlight[selflightObj.ib.ibFlight.length-1].flight.ArrAirport}}</CCol>
              </CRow>
            </CCol>

            <CCol>

               {{selflightObj.ib.ibFlight[0].flight.Via_Obj}}

            </CCol>
          </CRow>
        </CCardBody>
      </CCard >
      <CCollapse  v-show="ib.isIbFlight==true" class="mt-2">
        <CCard v-if="selflightObj.ib" body-wrapper @click="toggleFilghtDesc('ib',false)">
          <CCol>{{$t('selFlightInfo.departFlight')}} . {{selflightObj.ib.ibFlight[0].flight.DepDate|formatDate("ddd, DD MMM")}}</CCol>
          <CCol>
            <CRow>
              <CCol
                col="1"
                v-c-tooltip.hover="{
                                content:`${formatDate(selflightObj.ib.ibFlight[0].flight.DepDate)}
                                 on ${formatTime(selflightObj.ib.ibFlight[0].flight.DepDate)}  `,
                              }"
              >{{formatTime(selflightObj.ib.ibFlight[0].flight.DepDate)}}</CCol>.
              <CCol >{{getFlightName(selflightObj.ib.ibFlight[0].flight.DepAirport)}}.({{selflightObj.ib.ibFlight[0].flight.DepAirport}})</CCol>
            </CRow>
          </CCol>
          <CCol v-if="selflightObj.ib.ibFlight[0].flight.TotalDuration!=null">{{$t('selFlightInfo.TravlTime')}} - {{selflightObj.ib.ibFlight[0].flight.TotalDuration|convertToHrMin("minutes",
              "H [h] mm [m]")}}</CCol>
          <CCol>
            <CRow>
              <CCol
                col="1"
                v-c-tooltip.hover="{
                                content:`${formatDate(selflightObj.ib.ibFlight[selflightObj.ib.ibFlight.length-1].flight.ArrDate)}
                                 on ${formatTime(selflightObj.ib.ibFlight[selflightObj.ib.ibFlight.length-1].flight.ArrDate)}  `,
                              }"
              >{{formatTime(selflightObj.ib.ibFlight[selflightObj.ib.ibFlight.length-1].flight.ArrDate)}}</CCol>.
              <CCol>{{getFlightName(selflightObj.ib.ibFlight[selflightObj.ib.ibFlight.length-1].flight.ArrAirport)}} ({{selflightObj.ib.ibFlight[selflightObj.ib.ibFlight.length-1].flight.ArrAirport}})</CCol>
            </CRow>
          </CCol>
          <CCol>{{selflightObj.ib.ibFlight[0].flight.opAirline+' '+selflightObj.ib.ibFlight[0].flight.FlightNo}} . {{selflightObj.ib.ibFlight[0].flight.cabin}}</CCol>
        </CCard>
    </CCollapse>-->
</template>
<script>
    //import {IMAGE_PATH} from "../../mixin/ImagePathConst.js"

    import cPerPaxPriceInfo from "../../components/result/cPerPaxPriceInfo"
    import cTotalPriceInfo from "../../components/result/cTotalPriceInfo";

    import {TRIP, PAX, PAX_COUNT} from "../../util/constants.js";
    import Logger from "../../services/logger";
    import {VALIDATE_SUCCESS_RES, getErrorMessage} from "@/util/apiValidate.js";
    import router, {navigate, goBack} from "../../router/index";
    import {convertToHrMin} from "../../util/date/dateFunctions";
    import {
        LOG_TYPE,
        FILE_NAME,
        HTTP_CODES,
        API_VALUES
    } from "../../config/API_DATA";
    import {COMPONENT_NAME, PATHNAME,DATE_TIME_FORMAT} from "../../util/constants";
    import BaseConfiguration from "../../config/base.js";
    import SERVICE_URL from "../../config/API_DATA";
    import {mapGetters, mapActions} from "vuex";
    import cFareRule from "../../components/modal/cFareRule";
    import cConnectingFlightInfo from "./cConnectingFlightInfo"
import { cloneData } from '../../util/util';
    export default {
        name: COMPONENT_NAME.C_SELECTEDFLIGHT,
        components: {
            cFareRule,
            cPerPaxPriceInfo,
            cTotalPriceInfo,
            cConnectingFlightInfo

        },
        props: {
              isPayment:{
               type:Boolean,
              default: false
        },
            selflightObj: {
                type: Object,
                default: null
            },
            // selFlight: {
            //     type: Object,
            //     default: null
            // },
            isPaxPage: {
                type: Boolean,
                default: false
            },
            isSticky: {
                type: Boolean,
                default: false
            },
           
        },
        data: () => ({
          toShowDepConnectingInfo: false,
          toShowRetConnectingInfo: false,
           isPaymentFee:false,
            stickyHeightAni: false,
            defaultALImg: BaseConfiguration.defaultALImg,
            isSelInfoShowState: true,
            isFRModalshow: false,
            ob: {
                isObFlight: false
            },
            ib: {
                isIbFlight: false
            },
            isStopsForNonMyanmar: BaseConfiguration.isStopsForNonMyanmar,
            // defaultALImg: BaseConfiguration.defaultALImg,
        }),
        computed: {
           DATE_TIME_FORMAT()
          {
            return DATE_TIME_FORMAT
          },
            ...mapGetters("sResult", {
                sSelectedPricing: "GET_SEL_PRICING_OBJ",
                sSelObFlightObj: "GET_OB_FLIGHT_OBJ",
                sSelIbFlightObj: "GET_IB_FLIGHT_OBJ",
                 GET_AIRLINES: 'GET_AIRLINES',
                 GET_SELFLIGHT_FOR_FOOTER:"GET_SELFLIGHT_FOR_FOOTER"
            }),
            ...mapGetters("sCSearch", {
                sRoutesObj: "GET_ROUTES_OBJ",
                sSearchObj: "GET_SEARCH_OBJ",
                
            })
        },
        methods: {
          ...mapActions("sResult", {
      SET_OB_FLIGHT_OBJ: "SET_OB_FLIGHT_OBJ",
      SET_IB_FLIGHT_OBJ: "SET_IB_FLIGHT_OBJ",
    }),
    getSelFlightInfoForOb() {
       let retValue;
        try {
          if(BaseConfiguration.isDebug) console.log("getSelFlightInfoForOb");
         if(this.$route.path == PATHNAME.FLIGHTRESULTS){
           retValue=this.selflightObj.ob;
         }else{
            if(this.selflightObj&&this.selflightObj.ib&&this.selflightObj.ib.clientPricing){
            retValue=this.GET_SELFLIGHT_FOR_FOOTER&&this.GET_SELFLIGHT_FOR_FOOTER.ob?this.GET_SELFLIGHT_FOR_FOOTER.ob:this.selflightObj.ob;
            }else{
              retValue=this.selflightObj.ob;
            }
         }
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.C_SELECTEDFLIGHT,
                  "error in getSelFlightInfoForOb",
                  err.toString(),
                  "getSelFlightInfoForOb",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
        }, 
         getSelFlightInfoForIb() {
       let retValue;
        try {
          if(BaseConfiguration.isDebug) console.log("getSelFlightInfoForIb");
         if(this.$route.path == PATHNAME.FLIGHTRESULTS){
           retValue=this.selflightObj.ib;
         }else{
           if(this.selflightObj&&this.selflightObj.ib&&this.selflightObj.ib.clientPricing){
            retValue=this.GET_SELFLIGHT_FOR_FOOTER&&this.GET_SELFLIGHT_FOR_FOOTER.ib?this.GET_SELFLIGHT_FOR_FOOTER.ib:this.selflightObj.ib;

           }else{
               retValue=this.selflightObj.ib;
           }
         }
    
        } catch (err) {
                let body = Logger.buildRequest(
                  COMPONENT_NAME.C_SELECTEDFLIGHT,
                  "error in getSelFlightInfoForOb",
                  err.toString(),
                  "getSelFlightInfoForOb",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
          return retValue;
        }, 

     getClass(pClass) {
         try {
           if(BaseConfiguration.isDebug) console.log("getClass");
           let retValue;
          if(pClass){
            if(pClass.toString().length == 1)
            retValue = "flex-flow-row"
            else
            retValue = ""
          }
          return retValue;
         } catch (err) {
                 let body = Logger.buildRequest(
                   FILE_NAME.C_SELECTEDFLIGHT,
                   "error in getClass",
                   err.toString(),
                   "getClass",
                   LOG_TYPE.ERROR
                 );
                 Logger.getResponse(body);
               }
          // return retValue;
         }, 

          removeSelFlights(pselFlights) {
            // let retValue;
              try {
                if(BaseConfiguration.isDebug) console.log("removeSelFlights");
                if(pselFlights.ibFlight){
                  this.selflightObj.ib.selectStatus=0 ;
                   this.selflightObj.ib=null;
                   if(this.sSelIbFlightObj) {
                    this.$emit(
            "cToRemoveclassofFlight",null,this.sSelIbFlightObj);
                      this.SET_IB_FLIGHT_OBJ();
                      
                   }
                }else if(pselFlights.obFlight) {
                   this.selflightObj.ob.selectStatus=0 ;
                   this.selflightObj.ob=null;
                   if(this.sSelObFlightObj) {
                    this.$emit(
            "cToRemoveclassofFlight",null,this.sSelObFlightObj);
                      this.SET_OB_FLIGHT_OBJ();
                      
                   }
                }
                
          
              } catch (err) {
                      let body = Logger.buildRequest(
                        FILE_NAME.C_SELECTEDFLIGHT,
                        "error in removeSelFlights",
                        err.toString(),
                        "removeSelFlights",
                        LOG_TYPE.ERROR
                      );
                      Logger.getResponse(body);
                    }
                // return retValue;
              }, 

            goToSearchPage() {
                try {
                    if (BaseConfiguration.isDebug) console.log("goToSearchPage");
                    navigate(PATHNAME.FLIGHTSEARCH);
                   this.$emit('getModifySearch')


                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SELECTEDFLIGHT,
                        "error in goToSearchPage",
                        err.toString(),
                        "goToSearchPage",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }

            },
            onToggleFRModal() {
                try {
                    if (BaseConfiguration.isDebug) console.log("onToggleFRModal");
                    this.isFRModalshow = !this.isFRModalshow;
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.PAXPAGE,
                        "error in onToggleFRModal",
                        err.toString(),
                        "onToggleFRModal",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
            },
            getFlightName(pUnitFlight) {
                let retValue;
                try {
                    if (this.sRoutesObj && this.sRoutesObj.airports) {
                        retValue = this.sRoutesObj.airports[pUnitFlight].airportname;
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SELECTEDFLIGHT,
                        "error in getFlightName",
                        err.toString(),
                        "getFlightName",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            //to get formatted date and time
            formatDate(pDate) {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("formatDate");
                    if (pDate != null) {
                        retValue = this.$options.filters.formatDate(
                            pDate,DATE_TIME_FORMAT.FULL_DATE_DAY
                           
                        );
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SELECTEDFLIGHT,
                        "error in formatDate",
                        err.toString(),
                        "formatDate",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            formatTime(pDate) {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("formatTime");
                    if (pDate != null) {
                        retValue = this.$options.filters.formatDate(pDate, "HH: mm");
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SELECTEDFLIGHT,
                        "error in formatTime",
                        err.toString(),
                        "formatTime",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

            //to show and hide the flight desc
            toggleFilghtDesc(pboard, pbool) {
                let retValue;
                try {
                    if (pboard == "ob") retValue = this.ob.isObFlight = pbool;
                    else {
                        retValue = this.ib.isIbFlight = pbool;
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_SELECTEDFLIGHT,
                        "error in toggleFilghtDesc",
                        err.toString(),
                        "toggleFilghtDesc",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },


           
        },
        created() {
            let sel = ( this.selflightObj);

           
            /*let that = this;
            setTimeout(() => {
              that.isSelInfoShowState = !that.isSelInfoShowState;
            }, 2000);*/
        }
    };
</script>
<style>
    .bounce-enter-active {
        animation: bounce-in .5s;
    }

    .bounce-leave-active {
        animation: bounce-in .5s reverse;
    }

    @keyframes bounce-in {
        0%{
            transform: translate(0px, -10px);
            /*opacity: 0;*/
        }

        100%{
            transform: translate(0px, 0px);
            /*opacity: 1;*/
        }

        /*0% {*/
        /*    transform: scale(0);*/
        /*}*/
        /*50% {*/
        /*    transform: scale(1.1);*/
        /*}*/
        /*100% {*/
        /*    transform: scale(1);*/
        /*}*/
    }
</style>
